module.exports = __webpack_public_path__ + "img/visa.26981528.svg";